import React, { FC, useContext } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import NavWrapper from '../components/wrappers/NavWrapper'
import Locations from '../pages/locations'
import { userContext } from '../utils/userContext'

const LocationsRouter: FC = () => {
    let match = useRouteMatch()
    const { hasModule } = useContext(userContext)

    return (
        <NavWrapper pageName="Pladser">
            {!hasModule(match.url) ? <Route component={() => <div>Du har ikke adgang til pladshåndtering</div>}/> :
                <Switch>
                    <Route exact path={match.url} component={Locations}/>
                    <Route> <div>Siden bliv ikke fundet</div></Route>
                </Switch>
            }
        </NavWrapper>
    )
}

export default LocationsRouter
